// extracted by mini-css-extract-plugin
export default {"primaryColor":"var(--primary-color)","red":"var(--croonus-lightRed)"};